import { html, nothing, TemplateResult } from "lit/html.js";

const SocialButtonsTemplate = ({ messages, captchaEnabled, socialLogin, handleSocialSubmit }: ISocialButtonsTemplate): TemplateResult => html`
  <div class="social-login-within-popup">
    <p class="social-intro">
      <span>${messages.SocialSubscriptionIntroText}</span>
    </p>
    <div class="social-login-box">
    ${socialLogin.facebook ? html`
    <div
        class="social-login-button social-login-facebook ts-facebook"
        @click=${handleSocialSubmit}
      >
        <i class="icon icon-facebook ts-facebook" aria-hidden="true"></i>
        <span class="sr-only">Facebook</span>
      </div>
    ` : nothing}
    ${socialLogin.linkedin ? html`
    <div
        class="social-login-button social-login-linkedin ts-linkedin"
        @click=${handleSocialSubmit}
      >
        <i class="icon icon-linkedin ts-linkedin" aria-hidden="true"></i>
        <span class="sr-only">Linkedin</span>
      </div>
    ` : nothing}
    ${socialLogin.google ? html`
    <div
        class="social-login-button social-login-google ts-google"
        @click=${handleSocialSubmit}
      >
        <img class="icon-google ts-google" src="/static/img/icons/g-logo.png" alt="google social logo" aria-hidden="true" />
        <span class="sr-only">Google</span>
      </div>
    ` : nothing}
    </div>
    ${captchaEnabled ? html`
    <div id="modal-social-captcha-container"></div>
    `: nothing}
    <p class="disclaimer">${messages.SocialSubscriptionDisclaimer}</p>
  </div>
  `

export default SocialButtonsTemplate;